var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeogrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 156.87 40.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#00263c;}.cls-4{fill:#f0000a;}.cls-5{opacity:0.6;}.cls-6{clip-path:url(#clip-path-4);}.cls-7{opacity:0.4;}.cls-8{clip-path:url(#clip-path-5);}.cls-9{clip-path:url(#clip-path-6);}.cls-10{clip-path:url(#clip-path-7);}.cls-11{clip-path:url(#clip-path-8);}.cls-12{opacity:0.2;}.cls-13{clip-path:url(#clip-path-9);}.cls-14{clip-path:url(#clip-path-10);}.cls-15{opacity:0;}.cls-16{clip-path:url(#clip-path-11);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 156.87,
    height: 40.79
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.41,
    y: 20.39,
    width: 17.63,
    height: 20.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.16,
    y: 27.8,
    width: 17.18,
    height: 12.99
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.41,
    y: 0.19,
    width: 17.63,
    height: 20.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.16,
    width: 17.18,
    height: 12.99
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.27,
    y: 12.99,
    width: 16.02,
    height: 14.82
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 20.39,
    width: 13.41,
    height: 13.29
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 7.11,
    width: 13.41,
    height: 13.29
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 17.13,
    width: 5.27,
    height: 6.53
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RGB_Color_Positivo",
    "data-name": "RGB Color Positivo"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.37,30.82A8.6,8.6,0,0,1,74,30.19a7.57,7.57,0,0,1-4.19-4.25,8,8,0,0,1-.57-3,8.42,8.42,0,0,1,.56-3.1,7.51,7.51,0,0,1,1.61-2.56A7.71,7.71,0,0,1,74,15.5a8.57,8.57,0,0,1,3.39-.65,8.37,8.37,0,0,1,3.37.65,7.71,7.71,0,0,1,2.53,1.73,7.37,7.37,0,0,1,1.59,2.53,8.33,8.33,0,0,1,.54,3c0,.26,0,.5,0,.74a3.09,3.09,0,0,1-.08.59H73.42a4.5,4.5,0,0,0,.45,1.61,3.92,3.92,0,0,0,2.17,2,4.12,4.12,0,0,0,1.47.27,4.54,4.54,0,0,0,2.22-.58,3.06,3.06,0,0,0,1.43-1.51l3.38.94a7,7,0,0,1-2.72,2.9,8.49,8.49,0,0,1-4.46,1.13m4-9.3a4,4,0,0,0-1.28-2.77,3.89,3.89,0,0,0-2.75-1.05,4.18,4.18,0,0,0-1.48.28,4,4,0,0,0-1.22.78A4.34,4.34,0,0,0,73.76,20a4.22,4.22,0,0,0-.39,1.56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.94,30.82a8.49,8.49,0,0,1-3.38-.65A7.32,7.32,0,0,1,89,28.42a7.78,7.78,0,0,1-1.61-2.54,8.63,8.63,0,0,1,0-6.09A7.78,7.78,0,0,1,89,17.25a7.45,7.45,0,0,1,2.54-1.75,8.49,8.49,0,0,1,3.38-.65,8.37,8.37,0,0,1,3.37.65,7.58,7.58,0,0,1,4.13,4.29,8.52,8.52,0,0,1,0,6.09,7.73,7.73,0,0,1-1.59,2.54,7.28,7.28,0,0,1-2.53,1.75,8.45,8.45,0,0,1-3.38.65m-4-8a5.4,5.4,0,0,0,.31,1.87,4.5,4.5,0,0,0,.85,1.45,3.75,3.75,0,0,0,1.28,1,3.91,3.91,0,0,0,3.18,0,3.75,3.75,0,0,0,1.28-1,4.6,4.6,0,0,0,.85-1.47A5.45,5.45,0,0,0,99,22.82,5.29,5.29,0,0,0,98.66,21a4.6,4.6,0,0,0-.85-1.47,3.76,3.76,0,0,0-2.87-1.3,3.8,3.8,0,0,0-1.59.35,4.34,4.34,0,0,0-1.28,1A4.75,4.75,0,0,0,91.22,21a5.53,5.53,0,0,0-.31,1.85",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.37,30.61a6.34,6.34,0,0,1-2.82-.61,7,7,0,0,1-2.19-1.69,7.84,7.84,0,0,1-1.43-2.49,9.44,9.44,0,0,1,0-6.12,8.18,8.18,0,0,1,1.47-2.52,6.68,6.68,0,0,1,2.27-1.71,6.81,6.81,0,0,1,2.91-.62,6.05,6.05,0,0,1,3.15.81A6.87,6.87,0,0,1,117,17.82v-2.7h3.44V29.79a7,7,0,0,1-.65,3.06A6.66,6.66,0,0,1,118,35.14a7.81,7.81,0,0,1-2.71,1.44,10.74,10.74,0,0,1-3.42.5,9.79,9.79,0,0,1-4.25-.83,8.63,8.63,0,0,1-3-2.37l2.15-2.09A6.2,6.2,0,0,0,109,33.5a6.63,6.63,0,0,0,2.84.61,5.79,5.79,0,0,0,1.75-.25,4.11,4.11,0,0,0,1.48-.77,3.7,3.7,0,0,0,1-1.36,4.64,4.64,0,0,0,.36-1.94V27.85a5.16,5.16,0,0,1-2.14,2,6.41,6.41,0,0,1-3,.72m1.32-3.15a3.76,3.76,0,0,0,1.24-.21,4.33,4.33,0,0,0,2-1.38,3.84,3.84,0,0,0,.58-1V21.2A4.74,4.74,0,0,0,114.82,19a3.93,3.93,0,0,0-2.36-.82,3.37,3.37,0,0,0-1.65.39,4.33,4.33,0,0,0-1.27,1.06,4.82,4.82,0,0,0-.8,1.52,5.27,5.27,0,0,0-.28,1.76,4.7,4.7,0,0,0,.32,1.77,4.57,4.57,0,0,0,.89,1.44,4.19,4.19,0,0,0,1.35,1,3.85,3.85,0,0,0,1.67.35",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.16,18.53a7.79,7.79,0,0,0-3.2.69,4,4,0,0,0-2,2v9.33H123V15.12h3.62v3.29a6.8,6.8,0,0,1,1-1.43,7.36,7.36,0,0,1,1.2-1.1,5.39,5.39,0,0,1,1.31-.72,3.74,3.74,0,0,1,1.28-.25h.48a1.55,1.55,0,0,1,.31,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.09,15.12H138V30.53h-3.94Zm4.24-3.43a2.27,2.27,0,1,1-2.27-2.27h0a2.27,2.27,0,0,1,2.27,2.27",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.26,30.82a7,7,0,0,1-2.95-.62A7.07,7.07,0,0,1,142,28.5,7.94,7.94,0,0,1,140.48,26a8.79,8.79,0,0,1-.55-3.13,9.45,9.45,0,0,1,.51-3.12,8.44,8.44,0,0,1,1.43-2.53,6.7,6.7,0,0,1,2.18-1.7,6.12,6.12,0,0,1,2.76-.62,6,6,0,0,1,5.21,3V9.72H156V26a1.44,1.44,0,0,0,.21.88.9.9,0,0,0,.7.29v3.36a9.38,9.38,0,0,1-1.67.2,2.7,2.7,0,0,1-1.74-.53,1.9,1.9,0,0,1-.76-1.38l-.09-1a5.61,5.61,0,0,1-2.31,2.22,6.57,6.57,0,0,1-3,.75m1-3.35a3.75,3.75,0,0,0,1.15-.19,4,4,0,0,0,1.09-.55,4.61,4.61,0,0,0,.89-.82,3.27,3.27,0,0,0,.61-1V21.2a4.21,4.21,0,0,0-.66-1.19,5,5,0,0,0-2.11-1.57,3.28,3.28,0,0,0-1.2-.23,3.46,3.46,0,0,0-1.63.38,4,4,0,0,0-1.28,1,5,5,0,0,0-.82,1.52,5.29,5.29,0,0,0-.3,1.76,5.07,5.07,0,0,0,.33,1.8,4.65,4.65,0,0,0,.88,1.44,4,4,0,0,0,3.06,1.32",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.32 10.2 63.32 23.66 52.57 10.2 49.17 10.2 49.17 30.59 53.45 30.59 53.45 17.46 63.8 30.59 67.27 30.59 67.27 10.2 63.32 10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.61,5.91,31,5a57.58,57.58,0,0,1-9.75,15.39A57.79,57.79,0,0,1,31,35.79l1.57-.91a11.7,11.7,0,0,0,5.86-10.14V16.05A11.7,11.7,0,0,0,32.61,5.91",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.41,27.8a46.78,46.78,0,0,1,7.93,12.8,11.69,11.69,0,0,0,3.75-1.38L31,35.79a57.55,57.55,0,0,0-9.75-15.4,58.16,58.16,0,0,1-7.88,7.41",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4.16,33.68a11.75,11.75,0,0,0,1.69,1.2l7.53,4.34a11.71,11.71,0,0,0,8,1.38,47,47,0,0,0-7.93-12.8,57.63,57.63,0,0,1-9.25,5.88",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.29,20.39A57.58,57.58,0,0,0,31,5L25.09,1.57A11.69,11.69,0,0,0,21.34.19,47,47,0,0,1,13.41,13a58.72,58.72,0,0,1,7.88,7.4",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.34.19a11.71,11.71,0,0,0-8,1.38L5.85,5.91a11.75,11.75,0,0,0-1.69,1.2A57.63,57.63,0,0,1,13.41,13,47,47,0,0,0,21.34.19",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.41,13a47.23,47.23,0,0,1-8.14,7.4,47.7,47.7,0,0,1,8.14,7.41,58.16,58.16,0,0,0,7.88-7.41A58.72,58.72,0,0,0,13.41,13",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5.27,20.39A45.36,45.36,0,0,1,0,23.66v1.08a11.67,11.67,0,0,0,4.16,8.94,57.63,57.63,0,0,0,9.25-5.88,47.7,47.7,0,0,0-8.14-7.41",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.41,13A57.63,57.63,0,0,0,4.16,7.11,11.67,11.67,0,0,0,0,16.05v1.08a46.68,46.68,0,0,1,5.27,3.26A47.23,47.23,0,0,0,13.41,13",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,17.13v6.53a45.36,45.36,0,0,0,5.27-3.27A46.68,46.68,0,0,0,0,17.13",
    transform: "translate(0 0)"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeogrid);
export default __webpack_public_path__ + "static/media/neogrid.4dce997568d84db84a70a1956399b364.svg";
export { ForwardRef as ReactComponent };